import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import {
  fetchShiftCategories,
  createShiftCategory,
  updateShiftCategory,
  deleteShiftCategory,
} from "../api/shiftCategoryApi";
import type { ShiftCategoryRequest } from "./types";
import { useLookup } from '@/shared/hooks/useLookup';
import { lookupKeys } from '@/shared/queries/lookupKeys';

export const useShiftCategories = () =>
  useLookup({
    queryKey: lookupKeys.shiftCategory.root,
    queryFn: fetchShiftCategories,
    tier: 'reference',
  });

export const useCreateShiftCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ShiftCategoryRequest) => createShiftCategory(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: lookupKeys.shiftCategory.root });
      toast.success("Shift category created");
    },
  });
};

export const useUpdateShiftCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: ShiftCategoryRequest }) =>
      updateShiftCategory(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: lookupKeys.shiftCategory.root });
      toast.success("Shift category updated");
    },
  });
};

export const useDeleteShiftCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteShiftCategory(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: lookupKeys.shiftCategory.root });
      toast.success("Shift category deleted");
    },
  });
};
